import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import $ from "jquery";
class OurTeam extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

componentDidMount(){

}


toggle_info(id){
  if($("#"+id).hasClass("hide")){
    $("#"+id+"_i").text("Read Less...");
  }else {
    $("#"+id+"_i").text("Read More...")
  }
  $('#'+id).toggleClass('hide');
}



  render() {
    return (
        <div className="container-xxl py-5">
            <div className="container inner_con">
                <h1 className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">Our Team</h1>

                <section className="team-section">

              <div className="team-card long-text">
                <div className="team-image">
                  <img src="/assets/img/profile/prem_cudhary.png" alt="Prem Choudhary "/>
                </div>
                <div className="team-content">
                  <h3>Prem C. Choudhary</h3>
                  <div className="team-role team_role_mb">Managing Partner, BYLAWS Legal LLP</div>
                  <p><i>[B Sc, LLB, LLM (Cyber Laws), MBA (Financial markets), CS]</i></p>
                  <p>
                  Prem C. Choudhary is the Managing Partner of BYLAWS Legal LLP, a
                  governance-centric law firm built on precision, regulatory depth and institutional
                  advisory standards. With over 18 years of experience across India’s financial
                  services, capital markets and regulated ecosystems, he has held senior legal and
                  compliance leadership positions within LGT India, Times Internet/ET Money, Kotak
                  Mahindra bank, Kotak Securities, Bombay Stock Exchange etc. leading wealth management groups, stock
                  broking institutions, depository participant entities, NBFC structures and
                  technology-driven financial platforms.
                  </p>

                  <div className="hide" id='prem_cudhary'>
                  <p>
                  His professional journey reflects extensive engagement with Bombay Stock
                  Exchnage, SEBI-regulated intermediaries, exchange frameworks, enforcement
                  environments and board-level governance architecture. His core expertise spans
                  regulatory licensing and structuring, capital markets law, financial sector governance,
                  enforcement response strategy, AML architecture and complex corporate advisory.
                  </p>

                  <p>
                  A Company Secretary (Professional), LL.M. in Cyber Laws, MBA (Finance) and law
                  graduate, he brings rare convergence of legal, compliance, secretarial and financial
                  literacy to high-impact advisory mandates.
                  </p>

                  <p>
                  Under his leadership, BYLAWS Legal LLP is positioning not merely as a law firm but
                  as a strategic governance partner for institutions, promoters and boards seeking
                  legally fortified growth. His vision is to build BYLAWS into a benchmark institution
                  recognised for disciplined advisory, structural integrity and uncompromising
                  professional standards.
                  </p>

                  </div>
                  <p className="read_on" onClick={this.toggle_info.bind(this,'prem_cudhary')}><i id="prem_cudhary_i">Read More...</i></p>
                </div>
              </div>


              <div className="team-card reverse">
                <div className="team-image">
                  <img src="/assets/img/profile/kalyani_pate.jpg" alt="Kalyani Prakash Pate"/>
                </div>
                <div className="team-content">
                  <h3>Kalyani Prakash Pate</h3>
                  <div className="team-role team_role_mb">Partner, BYLAWS Legal LLP</div>
                  <p><i>[LLB, Post graduate diploma in IPR]</i></p>
                  <p>
                  Kalyani Prakash Pate is a Partner at BYLAWS Legal LLP, with a practice centred on
                  Maharashtra local legislations, real estate advisory and socially driven legal
                  intervention. She leads the firm’s pro-bono and victim support initiatives, focusing on
                  providing structured legal assistance to individuals facing financial distress, property
                  disputes, domestic challenges and regulatory hardship. Her work is grounded in
                  ensuring access to justice through responsible legal representation, guidance on
                  rights awareness and procedural support before local authorities and forums across
                  Maharashtra.
                  </p>


                  <div className="hide" id='kalyani_pate'>
                  <p>
                  Kalyani actively works with vulnerable stakeholders, offering advisory and
                  documentation assistance in matters involving local governance bodies, housing
                  societies, municipal compliances and revenue authorities. She plays a key role in
                  supporting victims requiring structured legal recourse, ensuring matters are handled
                  with sensitivity, confidentiality and procedural discipline.
                  </p>

                  <p>
                  In addition to her pro-bono focus, she provides targeted business support to Micro,
                  Small and Medium Enterprises (MSMEs), assisting them with regulatory
                  registrations, local compliance structuring, contract documentation, real estate due
                  diligence and operational risk mitigation under Maharashtra-specific frameworks. Her
                  advisory integrates practical ground-level regulatory navigation with legally sound
                  documentation, enabling small businesses and first-generation entrepreneurs to
                  operate within compliant and sustainable structures.
                  </p>

                  <p>
                  Through her work, Kalyani strengthens BYLAWS Legal LLP’s commitment to socially
                  responsible legal practice while reinforcing the firm’s capability in grassroots
                  regulatory support and MSME-oriented advisory across Maharashtra.
                  </p>

                  </div>
                  <p className="read_on" onClick={this.toggle_info.bind(this,'kalyani_pate')}><i id="kalyani_pate_i">Read More...</i></p>
                </div>
              </div>

              <div className="team-card">
                <div className="team-image">
                  <img src="/assets/img/profile/rajesh_thakur.png" alt="Rajesh Thakur"/>
                </div>
                <div className="team-content">
                  <h3>Rajesh Thakur</h3>
                  <div className="team-role team_role_mb">Empanelled Advocate – Real estate and Land laws</div>
                  <p><i>[LLB, LLM (Business Law)]</i></p>
                  <p>
                  Rajesh Thakur is an Advocate, bringing over 25 years of comprehensive
                  professional experience in the real estate sector, including more than eight years of
                  focused courtroom practice in property and civil litigation. His career uniquely
                  combines hands-on real estate development exposure with structured legal
                  advocacy, enabling him to approach complex land and project disputes with both
                  commercial depth and procedural rigour. This dual perspective positions him to
                  advise not merely on legal issues in abstraction, but on the practical realities of
                  documentation, regulatory approvals, project execution risks and dispute escalation.
                  </p>

                  <div className="hide" id="rajesh_thakur">
                  <p>
                  Holding a Bachelor’s degree, Bachelor of Laws and a Master of Laws (LL.M.) in
                  Business Law, Rajesh has developed a litigation practice concentrated in Property
                  and Land Laws, Real Estate Disputes, Labour and Employment Laws and Civil
                  Proceedings. He regularly represents clients in matters involving title and ownership
                  conflicts, development and joint venture disputes, conveyancing and documentation
                  challenges, land acquisition complexities, project-related contractual conflicts and
                  ancillary civil remedies before appropriate judicial and quasi-judicial forums.
                  </p>

                  <p>
                  He holds extensive sectoral involvement, including participation in the development
                  of resort and farm projects, and granular understanding of land due diligence,
                  regulatory interfaces, documentation structuring and compliance navigation. Through
                  his association with BYLAWS Legal LLP, he reinforces the firm’s dispute resolution
                  strength in high-value land and property matters, delivering legally robust,
                  commercially aware and strategically calibrated representation in accordance with
                  the highest professional standards.
                  </p>

                  </div>
                  <p className="read_on" onClick={this.toggle_info.bind(this,'rajesh_thakur')}><i id="rajesh_thakur_i">Read More...</i></p>
                </div>
              </div>


              <div className="team-card reverse">
                <div className="team-image">
                  <img src="/assets/img/profile/arun_poojary.png" alt="Arun Poojary"/>
                </div>
                <div className="team-content">
                  <h3>Arun Poojary</h3>
                  <div className="team-role team_role_mb">Vice president – Capital Market Regulatory Advisory, BYLAWS Legal LLP</div>
                  <p><i>[B.Com, LLB, DBM]</i></p>
                  <p>
                  Arun Kumar Poojary is Vice president – Capital Market Regulatory Advisory at BYLAWS Legal LLP, strengthening the
                  firm’s Capital Markets and Financial Regulatory Advisory practice with nearly two
                  decades of specialised experience in Exchange and depository compliances, AML
                  governance and regulator-facing frameworks. His professional journey includes
                  mid-senior roles with reputed institutions such as ICICI Securities Limited, Kotak
                  Securities Limited and Multi Commodity Exchange of India Limited, where he was
                  actively involved in exchange-regulated environments and institutional compliance
                  architecture.
                  </p>
                  <div className="hide" id="arun_poojary">
                  <p>
                  During his tenure as Assistant Vice President at ICICI Securities and with Kotak
                  Securities, he led regulatory inspection management involving Securities and
                  Exchange Board of India, National Stock Exchange of India and Bombay Stock
                  Exchange, CDSL, handling inspection observations, regulatory circular
                  implementation, enforcement responses and enterprise-level AML oversight. His
                  experience includes surveillance alert monitoring, suspicious transaction analysis
                  under the Prevention of Money Laundering Act, 2002, STR reporting frameworks,
                  depository participant compliance and capital adequacy supervision within
                  broker-dealer structures.
                  </p>

                  <p>
                  Arun’s core strengths lie in AML governance systems, regulatory response strategy,
                  exchange compliance implementation, surveillance and market abuse monitoring,
                  and institution-level compliance documentation structuring. He holds degrees in
                  Commerce and Law, a Diploma in Business Management, AML/KYC certification
                  from IIBF and NISM Series VII – Securities Operations & Risk Management
                  certification, reflecting a strong blend of legal, operational and risk management
                  capability.
                  </p>

                  <p>
                  Through his association with BYLAWS Legal LLP, Arun enhances the firm’s capacity
                  to advise intermediaries, brokers, depository participants and financial institutions on
                  regulator-ready compliance frameworks, inspection preparedness and risk-calibrated
                  capital markets governance, delivered in alignment with statutory standards and
                  institutional best practices.
                  </p>

                  </div>
                  <p className="read_on" onClick={this.toggle_info.bind(this,'arun_poojary')}><i id="arun_poojary_i">Read More...</i></p>
                </div>
              </div>


              <div className="team-card">
                <div className="team-image">
                  <img src="/assets/img/profile/vipul_jain.png" alt="Vipul Jain"/>
                </div>
                <div className="team-content">
                  <h3>Vipul Jain</h3>
                  <div className="team-role team_role_mb">Empanelled CA – BYLAWS Legal LLP</div>
                  <p><i>[CA]</i></p>
                  <p>
                  Vipul Jain is the Founder and Partner of Vipul N Jain & Associates, a firm of
                  Chartered Accountants engaged in audit, taxation and accounting-related
                  professional services, and is associated with BYLAWS Legal LLP in a professional
                  support capacity for financial, accounting and other related matters. An Associate
                  Member of the Institute of Chartered Accountants of India (ICAI), he brings over 16
                  years of experience across assurance, taxation and compliance-oriented advisory
                  assignments, supporting corporates, public trusts, NGOs and financial institutions.
                  </p>

                  <div className="hide" id="vipul_jain">
                  <p>
                  In coordination with BYLAWS Legal LLP, Vipul provides structured financial insight in
                  matters requiring audit interface, financial due diligence, accounting review, GST
                  advisory, company law compliance and regulatory reporting alignment. His
                  professional work includes statutory audits, internal and management audits,
                  systems consultancy, incorporation support, and structured interaction with statutory
                  authorities such as the Registrar of Companies and the Reserve Bank of India,
                  particularly in cross-border structuring and overseas client matters. His experience
                  further extends to participation in bank audits, including statutory, concurrent and
                  revenue audits, strengthening institutional review processes where financial scrutiny
                  intersects with legal structuring.
                  </p>

                  <p>
                  His engagement with BYLAWS Legal LLP enhances the firm’s multidisciplinary
                  capability by integrating financial compliance discipline with legal advisory
                  frameworks, ensuring that client matters involving regulatory filings, financial
                  governance and statutory reporting are addressed with technical precision and
                  professional rigor. His professional focus remains confined to accounting, audit,
                  taxation and allied services, delivered within the scope of chartered accountancy
                  standards.
                  </p>

                  <p>
                  <b>Disclaimer: </b>
                  Vipul Jain is a Chartered Accountant. His role and professional profile
                  relate exclusively to accounting, audit, taxation and allied advisory services. He does
                  not render legal advice. All legal services of BYLAWS Legal LLP are provided solely
                  by advocates enrolled with the Bar Council of India.
                  </p>

                  </div>
                  <p className="read_on" onClick={this.toggle_info.bind(this,'vipul_jain')}><i id="vipul_jain_i">Read More...</i></p>
                </div>
              </div>

              </section>


                 <div className="text-align-right">
                    <Link to="/ourteam" className="btn btn-primary py-3 px-5 mt-3">Know More</Link>
                 </div>
            </div>
        </div>
    );
  }
}

export default OurTeam;
